module.exports = __webpack_public_path__ + "img/certificate7.21c8afd0.jpg";